import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Person } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'

export default observer(function Collaborators() {
  const { collaborators } = useContext(CampaignContext)

  return (
    <div className="flex">
      {collaborators.map((collaborator, index) => (
        <div key={collaborator.id} className={index === 0 ? '' : '-ml-2'}>
          {collaborator.avatar?.url && <img className="w-9 h-9 rounded-full object-cover" src={collaborator.avatar?.url} alt="avatar"/>
          || <div className="w-9 h-9 bg-rb-green rounded-full text-white flex items-center justify-center border-1 border-white"><Person /></div>}
        </div>
      ))}
    </div>
  )
})
